module.exports = __webpack_public_path__ + "img/hefei_door.bea7e1d7.jpg";